import App from '../components/App';
import { renderClientIndex } from '@zg-rentals/rental-manager-env';
import { analytics } from '../analytics';

import { getClient } from '@zg-rentals/ts-client-http-client';
import { setClient } from '@zg-rentals/ts-user-management-client';
import { setClient as setRentalManagerClient } from '@zg-rentals/ts-rental-manager-api-client';

export const client = getClient().extend({
  prefixUrl: __DEV__ ? `${__API__}rental` : '/rental',
});

const rentalManagerClient = getClient().extend({
  prefixUrl: __DEV__ ? __API__ : '/',
});

setClient(client);
setRentalManagerClient(rentalManagerClient);

renderClientIndex({
  app: <App />,
  appName: __APP_NAME__,
  onBootstrapRegister: analytics.initialize,
});

if (module.hot) {
  module.hot.accept();
}
